module.exports = __webpack_public_path__ + "static/media/019.6b9bbdf4.jpg";